import React, { Component } from 'react';
import { Table } from 'reactstrap';
import i18n from '../../../../i18next';

import { 
    transformProductsComingFromServer, 
    transformProductPrice, 
    getPriceWithCurrencySymbol 
} from '../../../../utils/CommonUtils';

class ProductsDetailsTable extends Component {

    renderProductQuestions(product) {
        const orderQuestions = product.orderQuestions;

        return orderQuestions.map((question) => {
            const orderAnswers = (question.orderAnswers.length > 0) ? question.orderAnswers : null;

            return (
                <p key={question.id} style={{ marginBottom: 2, fontSize: 12 }}>{this.getQuestionAnswers(question, orderAnswers)}</p>
            );
        });
    }

    getQuestionAnswers(question, orderAnswers) {
        let answers = '';
        let removedAnswers = '';

        if (question.posDefault == true) {
            // Guard orderAnswers when it is null
            if (!orderAnswers) orderAnswers = [];

            orderAnswers.map((answer) => {
                if (answer.quantity > 1) {
                    answers += answer.name + '(' + answer.quantity + '), ';
                }
            });

            if (question.removedAnswers !== null && question.removedAnswers.length > 0) {
                question.removedAnswers.map((аnswer) => {
                    removedAnswers += 'No ' + аnswer.name + ', ';
                });
            }

            return answers.slice(0, -2) + ' ' + removedAnswers.slice(0, -2);
        } else if (orderAnswers !== null && orderAnswers.length > 0) {
            orderAnswers.map((answer) => {
                if (answer.quantity == 1) {
                    answers += i18n.t('screens:orderDetailsScreen.extra') + ' ' + answer.name + ', ';
                } else if (answer.quantity > 1) {
                    answers += i18n.t('screens:orderDetailsScreen.extra') + ' ' + answer.name + '(' + answer.quantity + '), ';
                }
            });

            return answers.slice(0, -2);
        }
    }

    renderProductPrice(product) {
        const productPrice = (product.quantity > 1) ? product.price * product.quantity : product.price;
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;
        const prodPrice = transformProductPrice(productPrice);
        const productPriceWithCurrency = getPriceWithCurrencySymbol(prodPrice, currency);

        if (product.promotionFreeProduct) {
            return (
                <span>{i18n.t('screens:orderDetailsScreen.free')}</span>
            );
        } else {
            return (
                <span>{productPriceWithCurrency}</span>
            );
        }
    }

    renderOrderProducts() {
        const { textAlignCenter, mealDealName, instructionsStyle } = this.props.styles;
        const products = this.props.orderDetails.order.orderProducts;
        const orderProducts = transformProductsComingFromServer(products);
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;

        return orderProducts.map(product => {

            if (product.length >= 1) {  //MEAL DEAL
                let mealDeal = product.slice(0, 1);
                let mealDealProducts = product.slice(1);
                const mealDealPrice = transformProductPrice(mealDeal[0].price);
                const mealDealPriceWithCurrency = getPriceWithCurrencySymbol(mealDealPrice, currency);

                return (
                    <tr key={product.id} className="d-flex">
                        <td className="col-4">
                            <p style={mealDealName}>{mealDeal[0].name}</p>
                        </td>
                        <td className="col-6" style={{ marginBottom: 0 }}>
                            {
                                mealDealProducts.map((mealDealProduct) => {

                                    return (
                                        <div>
                                            <br />
                                            <p style={{ marginBottom: 2 }}>{mealDealProduct.name}</p>
                                            {mealDealProduct ? this.renderProductQuestions(mealDealProduct) : null}
                                            <p style={instructionsStyle}>{(mealDealProduct.instruction !== null) ? <i>"{mealDealProduct.instruction.notes}"</i> : ''}</p>
                                        </div>
                                    );
                                })
                            }
                        </td>
                        <td className="col-1" style={textAlignCenter}>{mealDeal[0].quantity}</td>
                        <td className="col-1">{mealDealPriceWithCurrency}</td>
                    </tr>
                );
            } else {

                return (
                    <tr key={`key${product.id}`} className="d-flex">
                        <td className="col-4">{product.name} {(product.sizeName !== null) ? ' ' + product.sizeName : ''}</td>
                        <td className="col-6" style={{ marginBottom: 0 }}>
                            <p>{this.renderProductQuestions(product)}</p>
                            <p style={instructionsStyle}>{(product.instruction !== null) ? <i>"{product.instruction.notes}"</i> : ''}</p>
                        </td>
                        <td className="col-1" style={textAlignCenter}>{product.quantity}</td>
                        <td className="col-1">{this.renderProductPrice(product)}</td>
                    </tr>
                );
            }
        });
    }

    render() {
        return (
            <Table responsive>
                <thead>
                    <tr className="d-flex">
                        <th className="col-4">{i18n.t('screens:orderDetailsScreen.items')}</th>
                        <th className="col-6">{i18n.t('screens:orderDetailsScreen.contains')}</th>
                        <th className="col-1">{i18n.t('screens:orderDetailsScreen.quantity')}</th>
                        <th className="col-1">{i18n.t('screens:orderDetailsScreen.price')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderOrderProducts()}
                </tbody>
            </Table>
        )
    }
}

export default ProductsDetailsTable;


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/orderDetailsCommon/ProductsDetailsTable.js